import { ChevronRight } from '../../components/ui/icons';
import { Avatar } from '../../components/ui/bits';
import type { MiniLeague, User } from '@h2h/shared';
import { initials } from '../../lib/format';
import { cn } from '../../lib/cn';
import { profileCard } from '../profile/tokens';

export function ProfileInCommon({
  sharedMinis,
  mutualIds,
  mutualUsers,
  onOpenMini
}: {
  sharedMinis: MiniLeague[];
  mutualIds: string[];
  mutualUsers: Record<string, User> | undefined;
  onOpenMini: (miniLeagueId: string) => void;
}) {
  if (sharedMinis.length === 0 && mutualIds.length === 0) return null;

  return (
    <>
      <div className="pb-2 pt-9">
        <span className="text-[17px] font-extrabold tracking-tight text-ink">In common</span>
      </div>
      <div className="flex flex-col gap-[10px]">
        {sharedMinis.map((mini) => (
          <button
            key={mini.miniLeagueId}
            type="button"
            onClick={() => onOpenMini(mini.miniLeagueId)}
            className={cn('tap flex items-center gap-[13px] p-4 text-left transition-colors active:bg-wash', profileCard)}
          >
            <div className="grid h-[42px] w-[42px] shrink-0 place-items-center rounded-[13px] bg-gradient-to-br from-night2 to-night text-[12px] font-extrabold text-white">
              {initials(mini.name)}
            </div>
            <div className="min-w-0 flex-1">
              <div className="truncate text-[14px] font-bold tracking-snug text-ink">{mini.name}</div>
              <div className="truncate text-[11px] font-medium text-ink2">
                Private league · {mini.memberIds.length} members
              </div>
            </div>
            <ChevronRight width={18} height={18} strokeWidth={2.2} className="text-ink3" />
          </button>
        ))}
        {mutualIds.length > 0 && (
          <div className={cn('flex items-center gap-[13px] p-4', profileCard)}>
            <div className="flex items-center">
              {mutualIds.slice(0, 3).map((id, i) => (
                <Avatar
                  key={id}
                  name={mutualUsers?.[id]?.displayName ?? 'Friend'}
                  tone={mutualUsers?.[id]?.avatarTone ?? 0}
                  size={32}
                  className={cn('border-2 border-card', i > 0 && '-ml-[10px]')}
                />
              ))}
              {mutualIds.length > 3 && (
                <div className="-ml-[10px] grid h-8 w-8 place-items-center rounded-full border-2 border-card bg-fill2 text-[10px] font-extrabold text-ink2">
                  +{mutualIds.length - 3}
                </div>
              )}
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-[14px] font-bold tracking-snug text-ink">
                {mutualIds.length} mutual {mutualIds.length === 1 ? 'friend' : 'friends'}
              </div>
              <div className="truncate text-[11px] font-medium text-ink2">
                {mutualIds
                  .slice(0, 2)
                  .map((id) => (mutualUsers?.[id]?.displayName ?? 'Friend').split(/\s+/)[0])
                  .join(', ')}
                {mutualIds.length > 2 ? ` & ${mutualIds.length - 2} more` : ''}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
